export const blockIconsHardwareTvNew = (
	<span className='material-symbols-outlined'>tv</span>
);
